import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { UnsubscribeComponent } from '../../generals/Components';
import { generateDeleteText } from '../../helpers/helper';

@Component({
  selector: 'app-usergroupdelete',
  templateUrl: './usergroupdelete.component.html',
  styleUrls: ['./usergroupdelete.component.scss']
})
export class UsergroupdeleteComponent extends UnsubscribeComponent implements AfterViewInit {

  @ViewChild('input') input: ElementRef<HTMLInputElement>;

  deleteText: string = generateDeleteText();
  deleteInput: string|null = null;

  loading = false;

  delete(): void {
    this.loading = true;
    this.apiService.deleteUserGroup(this.config.data.userGroupId).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.close(true);
    }).add(() => {
      this.loading = false;
    });
  }

  close(result: boolean = false): void {
    this.ref.close(result);
  }

  ngAfterViewInit(): void {
    this.input.nativeElement.focus();
  }

  constructor(
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private apiService: ApiService
  ) {
    super()
  }
}
